<template>
    <div class="sort-content"   @mouseleave="leave">
        <div class="title">商品分类</div>
        <div class="sort_content scrollbar_content_none">
            <div class="sort_item flex-sb"   v-for="(item,index) in categoriesList" :key="index" @mouseover="showDetail(item)">
                <p class="item_keywords"  ><span>{{item.categoryName}} </span></p>
            </div>
        </div>
        <transition name="el-fade-in-linear">
            <div class="sort_detail scrollbar_content_none"  v-show="isDisplay" >
                <div class="detail_item flex" v-for="(item,index) in sortChildren" :key="index">
                    <div class="detail_item_name" ><p>{{item.categoryName}}</p></div>
                    <div class="detail_item_sort flex">
                        <p   v-for="(list,index1) in item.children" :key="index1"><span>|</span>{{list.categoryName}}</p>
                    </div>
                </div>
            </div>
        </transition>
    </div>
    </template>
    <script>
 
    import cmsOssApi from  '../../api/cms-oss/index';
    export default {
      props:{
            allCategoriesList: {
              type: Array,
              default: function () {
                 return []
              },
              
            },
      },
     
      data(){
        return {
           showFirstSort:false,
           isDisplay:false,
     
           sortChildren:[],
          //  categoriesList:[],
           recommendCategory:[]
    
        }
      },
      created(){
          this.getData()
      },
      computed:{
        categoriesList(){
          return this.mergeTree(this.allCategoriesList,this.recommendCategory)
        }
      },
      methods:{
        async getData() {
            let res = await cmsOssApi.purchaseAreaRecommendCategory();
            if(res.status==200){
              this.recommendCategory=res.data.categoryList
            }
            
        },
        //合并树
        mergeTree(target, source) {
            if (!target?.length || !source?.length) {
                return;
            }
            const more = [];
            source.forEach(sNode => {
                const tNode = target.find(tn => tn.categoryId === sNode.categoryId);
                if (!tNode) {
                    more.push(sNode);
                    return;
                }
                const { children: sChildren, ...props } = sNode;
                Object.assign(tNode, props);
                this.mergeTree(tNode.children, sChildren);
            });
            target.push(...more);
            return target;
        },
        show(){
           this.showFirstSort=true;
           this.isDisplay=false;
        },
        leave(){
              this.showFirstSort=false;
               this.isDisplay=false;
        },
        showDetail(data){
            this.sortChildren=data.children
            this.isDisplay=true;
        },
        closeDetail(){
            this.isDisplay=false;
        },
   
      }
      
    }
    </script>
    
    <style lang='scss' scoped>
    @import '@/assets/css/theme.scss';
    .allCategories{
        width: 220px;
        height: 40px;
        line-height: 40px;
        background:$main-col;
        color:#fff;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
        position: relative;
        z-index: 10;
        i{
          padding-left:20px;
        }
    
    
    }
     
    .sort-content{
      position: relative;
      .title{
        height: 46px;
        width: 100%;
        line-height: 46px;
        background: #2587FF;
        color: #FFFFFF;
        font-size: 16px;
        text-align: center;
      }
    }
    .sort_content{
      position: absolute;
      width: 180px;
      height:300px;
      left:0;
      background:#2D3C50;
      z-index: 99;
      color:#fff;
      font-size:14px;
      // padding:7px 0;
      overflow-y: auto;
      .sort_item{
            line-height: 38px;
            padding:0 10px;
            .item_keywords{
      
                span{
                    cursor: pointer;
                    i{
                        padding:0 4px;
                    }
                }
                span:hover{
                    // color: #007aff;
                    font-weight: 600;
                  i{
                    font-weight: 400;
                    }
                }
            }
        }
        .sort_item:hover{
            // color:rgb(37,135,255);
          color:#333333;
              background: #fff;
          }
    }
    .sort_detail{
      position: absolute;
      width: 834px;
      height:346px;
      top:0;
      left:180px;
      background: #fff;
      z-index: 999;
      padding:10px 20px;
      box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.21);
      .detail_item{
            border-bottom:1px solid #EEEEEE;
            line-height: 32px;
            font-size:12px;
            .detail_item_name{
                flex:0 0 120px;
                width: 120px;
                font-size:12px;
                font-weight: bold;
                color: #333333;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                cursor: pointer;
                p{
                    line-height: 22px;
                }
            }
            .detail_item_name:hover{
                color:$main-col;
                cursor: pointer;
            }
            .detail_item_sort{
                padding-left:20px;
                flex-wrap: wrap;
                p{
                    padding-right:10px;
                    color:#666666;
                    span{
                        padding-right:10px;
                        color:#d9d9d9;
                    }
                }
                p:hover{
                    color:rgb(37,135,255);
                    cursor: pointer;
                    span{
                        color:#d9d9d9;
                    }
                    
                }
    
            }
             
        }
    }
    
    
    </style>
    